export default __webpack_public_path__ + "assets/media/Mid_Banner_WEB.27adc4f0.webp";